import axios from "axios";
import { UserPreferences } from "../modules/account";

const account = {
  authenticate: () => axios.get("/api/v1/account/active"),
  login: (locale: string) =>
    window.location.assign(`/api/v1/oauth/login?locale=${locale}`),
  loginRedirect: (redirect: string, locale: string) =>
    window.location.assign(
      `/api/v1/oauth/login?redirect=${encodeURIComponent(
        redirect
      )}&locale=${locale}`
    ),
  logout: (locale: string) =>
    window.location.assign(`/api/v1/oauth/logout?locale=${locale}`),
  setUserPreferences: (userPreferences: UserPreferences) =>
    axios.put("/api/v1/account/active", { userPreferences }),
};

export default account;
